import { constants, mixpanel } from 'common/helpers'

import syncUserAndSubscription from './syncUserAndSubscription'


// it's a simplest way to pass data from begin to commit,
// bcs both methods are called in different paypal button callbacks
let _token
let _payPalToken
let _payPalSession
let _paypalSessionId

const setupBeginPayPal = ({ begin, sessionName }) => (values) => {
  mixpanel.track(constants.analyticsEvents.tech.beginPaypal)

  return begin(values)
    .then(
      ({ gatewaySessionId, paypalToken, [sessionName]: session, token }) => {
        _token = token
        _payPalToken = paypalToken
        _payPalSession = session
        _paypalSessionId = gatewaySessionId

        return paypalToken
      })
}

/**
 *
 * @param {function} commit
 * @param {string} sessionName
 * @returns {function({ paymentType: *, paypalSessionId: * })}
 */
const setupCommitPayPal = ({ commit, sessionName }) => (
  ({ paymentType, paypalSessionId }) => {
    const body = {
      token: _token,
      paypalToken: _payPalToken,
      [sessionName]: _payPalSession,
      paypalSessionId: paypalSessionId || _paypalSessionId,
    }

    mixpanel.track(constants.analyticsEvents.tech.commitPaypal)

    return commit(body)
      .then(
        (result) => {
          syncUserAndSubscription({ ...result, paymentType })

          return result
        })
  }
)


export {
  setupBeginPayPal,
  setupCommitPayPal,
}
